import { render, staticRenderFns } from "./AgentFilingCertificate.vue?vue&type=template&id=1b31d300&scoped=true"
import script from "./AgentFilingCertificate.vue?vue&type=script&lang=js"
export * from "./AgentFilingCertificate.vue?vue&type=script&lang=js"
import style0 from "./AgentFilingCertificate.vue?vue&type=style&index=0&id=1b31d300&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31d300",
  null
  
)

export default component.exports